import { render, staticRenderFns } from "./MarketInfo.vue?vue&type=template&id=4d78cd16&"
import script from "./MarketInfo.vue?vue&type=script&lang=js&"
export * from "./MarketInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports